export default __webpack_public_path__ + "warn.c2a5c25f.svg";